var _style, _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBancaSistemaNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 188",
    width: 100,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BS_Vert-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #b91f27 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m73.9 0.1h22.1c16.9 0 26.6 5.7 26.6 17.1 0 5.8-3.5 10.6-10.2 13.8 8.7 4.4 12.1 8.1 12.1 16.4 0 13.2-10.9 19.2-27.5 19.2h-23.1zm15.8 26.3h5.4c7.1 0 11.8-3.3 11.8-7.8 0-4.9-3.6-8-11-8h-6.2c0 0 0 15.8 0 15.8zm0 29.7h6.6c8.2 0 12.5-3.8 12.5-9.7 0-6.3-5.5-9.4-13.7-9.4h-5.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m172.3 0.1l19.8 66.5h-15l-4-14h-21.7l-4.5 14h-15.1l20.4-66.5zm-18.1 41.2h15.6l-7.6-26.9h-0.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m243.3 0.2v39.4h-0.3l-21.8-39.4h-17.2v66.5h14.3v-43h0.2l24.1 43h15v-66.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m283.9 46.6c0 7.2 4 9.1 10.2 9.1 6.3 0 10.3-1.9 10.3-9.1v-4.3h15.7v2.7c0 16-10.7 21.7-26 21.7-15.3 0-26-5.7-26-21.7v-23.2c0-15.9 10.7-21.7 26-21.7 15.3 0 26 5.8 26 21.7v0.2h-15.7v-1.8c0-7.1-4-9.1-10.3-9.1-6.2 0-10.2 2-10.2 9.1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m367.3 0.1l19.8 66.6h-15l-4-14h-21.8l-4.4 14h-15.1l20.3-66.5zm-18.1 41.2h15.6l-7.6-26.9h-0.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m107.2 83.4h280.2v16.7h-280.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m41.2 137.7c-2.8-6.5-6.5-9.3-12.3-9.3-6 0-9.3 2.9-9.3 7.6 0 10.3 37.6 11.1 37.6 32.6 0 11.9-10.4 19.7-28.1 19.7-13.7 0-24.3-5.8-28.8-19.4l16.6-2.7c1.9 8.3 8 11.2 13 11.2 5.9 0 10.4-3 10.4-8.2 0-12.9-37.6-13.1-37.6-32.4 0-11.8 9-19.2 26.5-19.2 15 0 24.2 7 27.1 16.7z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m73.8 117.5h16.9v70.9h-16.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m145.6 137.7c-2.8-6.5-6.5-9.3-12.4-9.3-6 0-9.3 2.9-9.3 7.6 0 10.3 37.7 11.1 37.7 32.6 0 11.9-10.4 19.7-28.1 19.7-13.7 0-24.3-5.8-28.8-19.4l16.6-2.7c1.9 8.3 8 11.2 13 11.2 5.9 0 10.4-3 10.4-8.2 0-12.9-37.6-13.1-37.6-32.4 0-11.8 9-19.2 26.5-19.2 15 0 24.2 7 27.1 16.7z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m171.8 117.5v11.9h19.7v59h16.8v-59h19.7v-11.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m242 117.5v70.9h47.4v-12h-30.5v-18.7h22.3v-12h-22.3v-16.3h29.3v-11.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m363.6 117.5l-15.2 46.5h-0.3l-15.3-46.5h-23.5v70.9h14.4v-55.8h0.2l18 55.8h12.7l17.9-55.8h0.3v55.8h14.4v-70.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m438.4 117.5l21.3 70.9h-16.1l-4.3-15h-23.3l-4.8 15h-16.2l21.8-70.9zm-19.4 43.9h16.8l-8.2-28.6h-0.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m73.9 83.4h16.8v16.7h-16.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancaSistemaNew);
export default __webpack_public_path__ + "static/media/banca_sistema_new.73f793d41572eb8aad827fe888ae0464.svg";
export { ForwardRef as ReactComponent };